function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "48.958%",
  y1: "-1.222%",
  x2: "48.958%",
  y2: "98.422%",
  id: "cartes-bancaires_svg__b"
}, React.createElement("stop", {
  stopColor: "#1B1F46",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#1B1F46",
  offset: "35%"
}), React.createElement("stop", {
  stopColor: "#2C4B84",
  offset: "47%"
}), React.createElement("stop", {
  stopColor: "#3665A9",
  offset: "55%"
}), React.createElement("stop", {
  stopColor: "#3565A5",
  offset: "61%"
}), React.createElement("stop", {
  stopColor: "#33659A",
  offset: "66%"
}), React.createElement("stop", {
  stopColor: "#306487",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#2B636C",
  offset: "77%"
}), React.createElement("stop", {
  stopColor: "#256349",
  offset: "82%"
}), React.createElement("stop", {
  stopColor: "#216230",
  offset: "85%"
}), React.createElement("stop", {
  stopColor: "#216230",
  offset: "100%"
})), React.createElement("rect", {
  id: "cartes-bancaires_svg__a",
  x: 0,
  y: 0,
  width: 100,
  height: 60,
  rx: 4
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "cartes-bancaires_svg__c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#cartes-bancaires_svg__a"
})), React.createElement("use", {
  fill: "#00324F",
  xlinkHref: "#cartes-bancaires_svg__a"
}), React.createElement("path", {
  fill: "url(#cartes-bancaires_svg__b)",
  fillRule: "nonzero",
  mask: "url(#cartes-bancaires_svg__c)",
  d: "M-.66-.71h102v61h-102z"
}), React.createElement("g", {
  mask: "url(#cartes-bancaires_svg__c)",
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M39.37 28.77h11.44c-.1-2.26-.68-4.59-2.43-6.08-2.08-1.78-5.72-2.45-9-2.45-3.28 0-7.12.76-9.21 2.64-1.8 1.65-2.17 4.3-2.17 6.68s.74 5.44 2.7 7.07c1.96 1.63 5.45 2.25 8.7 2.25 3.25 0 6.58-.54 8.65-2.23 2.07-1.69 2.78-4.52 2.78-7.09H39.37v-.79zm12.21.78v8.91h15.91a4.41 4.41 0 0 0 4.18-4.39 4.52 4.52 0 0 0-4.18-4.52H51.58zm19.79-4.86a4 4 0 0 0-4.07-4.07H51.58v8.17h16a4.1 4.1 0 0 0 3.79-4.1z"
})));

var SvgCartesBancaires = function SvgCartesBancaires(props) {
  return React.createElement("svg", _extends({
    width: 100,
    height: 60
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/cartes-bancaires.dc3f3e3b.svg";
export { SvgCartesBancaires as ReactComponent };